<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>เอกสาร/รูปประจำตัว</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs6 md3>
          <dropzone-uploader 
            ref="formal" 
            id="formal" 
            :options="dropzoneOptions" 
            @vdropzone-file-added="fileAdded($event, `FORMAL`)" 
            @vdropzone-success="uploadSuccess" 
            @vdropzone-removed-file="removeFile"
            @vdropzone-error="uploadError"
            :useCustomSlot="active"
          >
            <div class="dropzone-custom-content">
              <div class="subtitle">สถานะ: ปิดการใช้งาน</div>
            </div>
          </dropzone-uploader>
        </v-flex>
        <v-flex xs3>
          <v-list subheader>
            <v-subheader class="blue-grey--text"><strong>รูปทางการ</strong></v-subheader>

            <v-list-tile v-if="personData.imageFormal">
              <v-list-tile-content>
                <v-list-tile-title>
                <a :href="download(personData.imageFormal)">{{personData.imageFormal.filename}}</a>
              </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click.native="onDeleteFile(`FORMAL`)">
                  <v-icon color="grey lighten-1">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>  
          </v-list>
        </v-flex>

        <v-flex xs6 md3>
          <dropzone-uploader 
            ref="informal" 
            id="informal" 
            :options="dropzoneOptions" 
            @vdropzone-file-added="fileAdded($event, `INFORMAL`)" 
            @vdropzone-success="uploadSuccess" 
            @vdropzone-removed-file="removeFile"
            @vdropzone-error="uploadError"
          ></dropzone-uploader>
        </v-flex>
        <v-flex xs6 md3>
          <v-list subheader>
            <v-subheader class="blue-grey--text"><strong>รูปส่วนตัว</strong></v-subheader>

            <v-list-tile v-if="personData.imageInformal">
              <v-list-tile-content>
                <v-list-tile-title>
                <a :href="download(personData.imageInformal)">{{personData.imageInformal.filename}}</a>
              </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click.native="onDeleteFile(`INFORMAL`)">
                  <v-icon color="grey lighten-1">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6 md3>
          <dropzone-uploader 
            ref="idcard" 
            id="idcard" 
            :options="dropzoneOptions" 
            @vdropzone-file-added="fileAdded($event, `IDCARD`)" 
            @vdropzone-success="uploadSuccess" 
            @vdropzone-removed-file="removeFile"
            @vdropzone-error="uploadError"
          ></dropzone-uploader>
        </v-flex>
        <v-flex xs6 md3>
          <v-list subheader>
            <v-subheader class="blue-grey--text"><strong>บัตรประจำตัวประชาชน</strong></v-subheader>

            <v-list-tile v-if="personData.attachmentIdCard">
              <v-list-tile-content>
                <v-list-tile-title>
                <a :href="download(personData.attachmentIdCard)">{{personData.attachmentIdCard.filename}}</a>
              </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click.native="onDeleteFile(`IDCARD`)">
                  <v-icon color="grey lighten-1">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>

        <v-flex xs6 md3>
          <dropzone-uploader 
            ref="passport" 
            id="passport" 
            :options="dropzoneOptions" 
            @vdropzone-file-added="fileAdded($event, `PASSPORT`)" 
            @vdropzone-success="uploadSuccess" 
            @vdropzone-removed-file="removeFile"
            @vdropzone-error="uploadError"
          ></dropzone-uploader>
        </v-flex>
        <v-flex xs6 md3>
          <v-list subheader>
            <v-subheader class="blue-grey--text"><strong>หนังสือเดินทาง</strong></v-subheader>

            <v-list-tile v-if="personData.attachmentPassport">
              <v-list-tile-content>
                <v-list-tile-title>
                <a :href="download(personData.attachmentPassport)">{{personData.attachmentPassport.filename}}</a>
              </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click.native="onDeleteFile(`PASSPORT`)">
                  <v-icon color="grey lighten-1">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6 md3>
          <dropzone-uploader 
            ref="vehicle" 
            id="vehicle" 
            :options="dropzoneOptions" 
            @vdropzone-file-added="fileAdded($event, `VEHICLE`)" 
            @vdropzone-success="uploadSuccess" 
            @vdropzone-removed-file="removeFile"
            @vdropzone-error="uploadError"
          ></dropzone-uploader>
        </v-flex>
        <v-flex xs6 md3>
          <v-list subheader>
            <v-subheader class="blue-grey--text"><strong>ทะเบียนรถ</strong></v-subheader>

            <v-list-tile v-if="personData.attachmentVehicle">
              <v-list-tile-content>
                <v-list-tile-title>
                <a :href="download(personData.attachmentVehicle)">{{personData.attachmentVehicle.filename}}</a>
              </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click.native="onDeleteFile(`VEHICLE`)">
                  <v-icon color="grey lighten-1">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'
import DropzoneUploader from 'vue2-dropzone'

// FORMAL, INFORMAL, IDCARD, PASSPORT, VEHICLE
export default {
  mixins: [ hasAccessMixin ],
  props: [ 'personId' ],
  components: {
    DropzoneUploader
  },
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      dropzoneOptions: {
        url: this.$store.getters['person/uploadUrl'],
        headers: { 'Authorization': ['Bearer', this.$store.getters.token].join(' ') },
        method: 'post',
        autoProcessQueue: true,
        addRemoveLinks: true,
        createImageThumbnails: true,
        acceptedFiles: 'image/*, .doc, .docx, .xls, .xlsx, .pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain',
        maxFiles: 1,
        parallelUploads: 1,
        maxFilesize: 1,
        params: {
          personId: this.personId,
          documentType: 'NONE'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      personData: 'person/personData'
    }),
    active () {
      return true
    }
  },
  created () {
    this.reload ()
  },
  methods: {
    fileAdded (file, documentType) {
      console.log("fileAdded", file)
      this.dropzoneOptions.params.documentType = documentType
    },
    uploadSuccess (file, response) {
      console.log("uploadSuccess", response)
      swal('บันทึกเรียบร้อย!', '', 'success')
      setTimeout( ()=> {
        this.reload ()
        switch(this.dropzoneOptions.params.documentType) {
          case 'FORMAL': 
            console.log('case FORMAL')
            this.$refs.formal.removeAllFiles()
            break;
          case 'INFORMAL':
            console.log('case INFORMAL')
            this.$refs.informal.removeAllFiles()
            break;
          case 'IDCARD': 
            console.log('case IDCARD')
            this.$refs.idcard.removeAllFiles()
            break;
          case 'PASSPORT':
            console.log('case PASSPORT')
            this.$refs.passport.removeAllFiles()
            break;
          case 'VEHICLE':
            console.log('case VEHICLE')
            this.$refs.vehicle.removeAllFiles()
            break;
          default:
            //statements;
            break;
        }        
      }, 1000)
    },
    uploadError (file, message, xhr) {
      console.log("uploadError", message)
    },
    removeFile (file, error, xhr) {
      console.log("removeFile", file)
    },
    onSubmit (type) {
      this.dropzoneOptions.params.documentType = type
      console.log('onSubmit called.', type)
      // this.$refs.formal.processQueue()
      switch(this.dropzoneOptions.params.documentType) {
        case 'FORMAL': 
          console.log('case FORMAL')
          this.$refs.formal.processQueue()
          break;
        case 'INFORMAL':
          console.log('case INFORMAL')
          this.$refs.informal.processQueue()
          break;
        case 'IDCARD': 
          console.log('case IDCARD')
          this.$refs.idcard.processQueue()
          break;
        case 'PASSPORT':
          console.log('case PASSPORT')
          this.$refs.passport.processQueue()
          break;
        case 'VEHICLE':
          console.log('case VEHICLE')
          this.$refs.vehicle.processQueue()
          break;
        default:
          //statements;
          break;
      } // FORMAL, INFORMAL, IDCARD, PASSPORT, VEHICLE
    },
    onDeleteFile (documentType) {
      // console.log('onDeleteFile called.', documentType)
      const data = {
        id: this.personId,
        documentType: documentType
      }
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('person/deleteFile', data)
            .then((response) => {
              console.log('onDeleteFile:', response )
              this.reload()
            }).catch((error) => {
              swal('Error!', error.message, 'error')
            })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    download (doc) {
      // console.log('download called.')
      return `${this.$store.getters['attachmentDocument/downloadUrl']}/${doc.id}?access_token=${this.$store.getters.token}`
    },
    reload () {
      this.$store.dispatch('person/fetchPerson', this.personId)
    }
  },
  watch: {
    'personData.imageFormal' (val) {
      val?this.$refs.formal.disable():this.$refs.formal.enable()
    },
    'personData.imageInformal' (val) {
      val?this.$refs.informal.disable():this.$refs.informal.enable()
    },
    'personData.attachmentIdCard' (val) {
      val?this.$refs.idcard.disable():this.$refs.idcard.enable()
    },
    'personData.attachmentPassport' (val) {
      val?this.$refs.passport.disable():this.$refs.passport.enable()
    },
    'personData.attachmentVehicle' (val) {
      val?this.$refs.vehicle.disable():this.$refs.vehicle.enable()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/shows/document/index.vue